import React, { useState } from 'react';
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from 'react-router-dom';
import ErrorPage from './error/ErrorPage';
import OrderSearchPage from './pages/OrderSearchPage';
import ConfirmationPage from './pages/ConfirmationPage';
import MaintenanceConfigPage from './pages/MaintenanceConfigPage';
import Loading from './library/Loading';


// layouts
import RootLayout from './layouts/RootLayout'

const OrderResults = React.lazy(() => import('./components/OrderResults'))

const router = createBrowserRouter(
  createRoutesFromElements(
  <Route path='/' element={<RootLayout />}>
      <Route index element={<OrderSearchPage pageType='search' />} />
      <Route path="confirmation" element={<ConfirmationPage />} />
      <Route path="orderresults" element={
        <React.Suspense fallback={<Loading>Please wait...</Loading>}>
          <OrderResults />
          </React.Suspense>} />
      <Route path="maintenance-config" element={<MaintenanceConfigPage />} />
      <Route path='error' element={<ErrorPage />} />
      <Route path='*' element={<ErrorPage />} />
  </Route>
  )
)

function App() {

  return (
    <RouterProvider router={router} future={{ v7_startTransition: true }} />

    // <>
    //   <Header
    //     getHeader = {getHeader}
    //     isHomePage = {isHomePage}
    //   >

    //   </Header>
    //   <HomePage
    //     getHeader ={getHeader}
    //     isHomePage = {isHomePage}
    //   >
    //   </HomePage>
    //   <Footer></Footer>
    // </>
  )
}

export default App
